//video
//кнопка play
[].forEach.call(document.querySelectorAll('.media-video__play'), function videPlay(el) {
    el.addEventListener('click', function videPlayEl(event) {
        event.currentTarget.closest('.media-video').querySelector('video').play();
        event.currentTarget.closest('.media-video').classList.add('play');
    })
});


window.onYouTubeIframeAPIReady = () => {
    const $$players = document.querySelectorAll('.media-youtube');
    $$players.forEach(item => {
        // eslint-disable-next-line
        const player = new YT.Player(item.querySelector('iframe'), {
            events: {
                onReady,
            }
        });

        function play() {
            item.classList.add('play');
            player.playVideo();
        }

        function stop() {
            item.classList.remove('play');
            player.stopVideo();
        }

        function onSlideChange(swiper) {
            swiper.on('slideChange', stop)
        }

        function onReady() {
            item.querySelector('.media-youtube__play').addEventListener('click', (e) => {
                item.classList.contains('play') ? stop() : play();
            });
    
            const $swiper = item.closest('.swiper-container');
    
            if ($swiper) {
                if ($swiper.classList.contains('swiper-initialized')) {
                    onSlideChange($swiper.swiper);
                } else {
                    $swiper.addEventListener('swiperInit', e => onSlideChange(e.target.swiper));
                }
            }
        }
    });
};

let newScript = document.createElement("script");
newScript.src = "https://www.youtube.com/iframe_api";
document.head.append(newScript);

//pause
[].forEach.call(document.querySelectorAll('.media-video video'), function video(el) {
    el.addEventListener('click', function videoEl(event) {
        event.currentTarget.pause();
        event.currentTarget.closest('.media-video').classList.remove('play');
    })
});

//mp3
//кнопка play
[].forEach.call(document.querySelectorAll('.media-audio__play'), function audioPlay(el) {
    el.addEventListener('click', function audioPlayEl(event) {
        if (event.target.closest('.media-audio').classList.contains('play')) {
            event.currentTarget.closest('.media-audio').querySelector('audio').pause();
            event.currentTarget.closest('.media-audio').classList.remove('play');
        }
        else {
            event.currentTarget.closest('.media-audio').querySelector('audio').play();
            event.currentTarget.closest('.media-audio').classList.add('play');
        }
    })
});
//track
[].forEach.call(document.querySelectorAll('.media-audio audio'), function audio(el) {
    el.addEventListener('timeupdate', function audioEl(event) {
        let seekSlider = event.currentTarget.closest('.media-audio').querySelector('.seek');
        seekSlider.max= el.duration;
        seekSlider.setAttribute("value", el.currentTime);
        seekSlider.value = el.currentTime;
        let percent = el.currentTime * 100 / el.duration;
        event.currentTarget.closest('.media-audio').querySelector('.media-audio__track-active').style.width=percent+"%";
        if (el.ended) {
        //end
        }
    })
});
